import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loading: -1,
  },
  isInitial: false,
  data: null,
  token: null,
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPES.PUNUB_CONFIG_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 0,
        },
      };
    case ACTION_TYPES.PUNUB_CONFIG_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.PUNUB_CONFIG_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 2,
        },
      };
    case ACTION_TYPES.PUBNUB_INIT:
      return {
        ...state,
        isInitial: true,
      };
    case ACTION_TYPES.PUBNUB_DESTROY:
      return {
        ...state,
        isInitial: false,
      };
    case ACTION_TYPES.PUNUB_GRANT_TOKEN_REQUESTED:
    case ACTION_TYPES.PUNUB_GRANT_TOKEN_FAILED:
      return {
        ...state,
        token: null,
      };
    case ACTION_TYPES.PUNUB_GRANT_TOKEN_SUCCEED:
      return {
        ...state,
        token: payload.data.token,
      };
    default:
      return state;
  }
}
